module.exports = __webpack_public_path__ + "static/media/ios-disc.870f2dd8.svg";